import { render } from "./App.vue?vue&type=template&id=1685c8fa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1685c8fa&lang=css"

import exportComponent from "P:\\FTH\\Projekte\\GemeindeApp\\97475_Zeil-am-Main\\svn\\trunk\\vue-pwa-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__